import type { PersonalizationTagInterface, ResponseInterface } from '~/types'

export const getPersonalizationTagsQuery = () => {
  return useQuery([VQGetPersonalizationTags], {
    queryFn: () =>
      useRequest().get<ResponseInterface<Array<PersonalizationTagInterface>>>(
        'broadcasts/tags',
      ),
    staleTime: process.dev || import.meta?.dev ? 0 : Infinity,
    select: ({ data: { data } }) => data,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 15,
  })
}
